import './style/cooperative.scss'



var map = new AMap.Map('map', {
  resizeEnable: true, //是否监控地图容器尺寸变化
  zoom: 16, //初始地图级别
  center: [120.350504, 30.299434], //初始地图中心点
  //center: [120.372149,30.304148], //初始地图中心点
  showIndoorMap: false //关闭室内地图
});
var marker = new AMap.Marker({
  icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
  position: [120.350504, 30.299434]
});
map.add(marker);



var clickFlag = true;
$('body').on('click', '.submit-btn', function (e) {
  e.preventDefault();
  var company = $('#company').val()
  var companyAddress = $('#companyAddress').val()
  var companyOfficialWebsite = $('#companyOfficialWebsite').val()
  var username = $('#username').val()
  var contact = $('#contac').val()
  var email = $('#email').val()
  var feedback = $('#feedback').val()


  var url = 'https://www.agrobot-uav.com/qfly/mail/sendFeedbackMail'
  if (clickFlag) {
    clickFlag = false
    if (username !== '' || contact !== '' || feedback !== '') {
      $.ajax({
        url: url,
        type: 'POST',
        data: JSON.stringify({
          company,
          companyAddress,
          companyOfficialWebsite,
          username,
          contact,
          email,
          feedback
        }),
        dataType: "json",
        contentType: 'application/json;charset=UTF-8',
        success: function (result) {
          switch (result.status) {
            case 200:

              $('#username').val('')
              $('#contac').val('')
              $('#email').val('')
              $('#company').val('')
              $('#companyAddress').val('')
              $('#companyOfficialWebsite').val('')
              $('#continent').val('')
              $('#country').val('')
              $('#feedback').val('')

              alert('提交成功')
              break;

            default:
              break;
          }

        },
        error: function () {
          alert('提交失败')
        }
      })
    } else {
      alert('请填写完整信息')
    }
    setTimeout(function () {
      clickFlag = true
    }, 1000)
  }
})